import {
    ActionTypes,
    MenubarModel
} from './model'

const initState = {};

export default function handler(state = new MenubarModel(initState), actions) {
    if (actions.type === ActionTypes.SET_STATUS) {
        return new MenubarModel({
            ...state,
            isExpandMenu: actions.payload
        });
    }
    return state;
}